function _typeof(o) {
  '@babel/helpers - typeof';
  return (
    (_typeof =
      'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o &&
              'function' == typeof Symbol &&
              o.constructor === Symbol &&
              o !== Symbol.prototype
              ? 'symbol'
              : typeof o;
          }),
    _typeof(o)
  );
}
var _excluded = [
  'prefixCls',
  'className',
  'children',
  'exportDataCount',
  'goToDownloadCenter',
  'confirm',
  'dropdown',
  'onClick',
  'noSecondConfirmation',
  'getPopupContainer',
];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r &&
      (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })),
      t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
      ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
      : ownKeys(Object(t)).forEach(function (r) {
          Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, 'string');
  return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== 'object' || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || 'default');
    if (_typeof(res) !== 'object') return res;
    throw new TypeError('@@toPrimitive must return a primitive value.');
  }
  return (hint === 'string' ? String : Number)(input);
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t =
    null == r ? null : ('undefined' != typeof Symbol && r[Symbol.iterator]) || r['@@iterator'];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {}
    } catch (r) {
      (o = !0), (n = r);
    } finally {
      try {
        if (!f && null != t.return && ((u = t.return()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React, { useCallback, useMemo } from 'react';
import { Button, notification, message, Modal } from 'udesk-ui';
import classNames from 'classnames';
import { usePrefixCls } from '../utils';
import { useLocaleReceiver } from '../locale-provider/LocaleReceiver';
import { ArrowDownSOutlined, ExportOutlined } from '@udesk/icons';
import BatchedActions from '../batched-actions';
var confirm = Modal.confirm;
var ExportButton = function ExportButton(props) {
  var customizePrefixCls = props.prefixCls,
    className = props.className,
    children = props.children,
    exportDataCount = props.exportDataCount,
    goToDownloadCenter = props.goToDownloadCenter,
    confirmProps = props.confirm,
    dropdown = props.dropdown,
    onClick = props.onClick,
    _props$noSecondConfir = props.noSecondConfirmation,
    noSecondConfirmation = _props$noSecondConfir === void 0 ? false : _props$noSecondConfir,
    getPopupContainer = props.getPopupContainer,
    rest = _objectWithoutProperties(props, _excluded);
  var _useLocaleReceiver = useLocaleReceiver('ExportButton'),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 1),
    contextLocale = _useLocaleReceiver2[0];
  var _usePrefixCls = usePrefixCls('export-button', customizePrefixCls),
    _usePrefixCls2 = _slicedToArray(_usePrefixCls, 2),
    buttonPrefixCls = _usePrefixCls2[0],
    prefixCls = _usePrefixCls2[1];
  var classes = classNames(buttonPrefixCls, className);
  var isExportAll = function isExportAll() {
    return typeof exportDataCount !== 'number';
  };
  var onOk = useCallback(
    function (type) {
      var _props$onClick, _props$onClick$call;
      return (_props$onClick = props.onClick) === null || _props$onClick === void 0
        ? void 0
        : (_props$onClick$call = _props$onClick.call(props, type)) === null ||
          _props$onClick$call === void 0
        ? void 0
        : _props$onClick$call.then(function () {
            notification.success({
              key: ''.concat(Math.random()),
              message: contextLocale.lang.successfully,
              getContainer: getPopupContainer,
              description: /*#__PURE__*/ React.createElement(
                'div',
                null,
                contextLocale.lang.pleaseJumpTo,
                /*#__PURE__*/ React.createElement(
                  Button,
                  {
                    prefixCls: ''.concat(prefixCls, '-btn'),
                    type: 'link',
                    size: 'small',
                    onClick: goToDownloadCenter,
                  },
                  contextLocale.lang.uploadAndDownloadCenter,
                ),
                contextLocale.lang.check,
              ),
            });
          });
    },
    [props.onClick, goToDownloadCenter, getPopupContainer],
  );
  var defaultConfirmProps = useMemo(
    function () {
      return _objectSpread(
        _objectSpread(
          {
            title: isExportAll()
              ? contextLocale.lang.exportAll
              : ''
                  .concat(contextLocale.lang.total, ' ')
                  .concat(exportDataCount || 0, ' ')
                  .concat(contextLocale.lang.confirm),
            // icon: <ExclamationCircleOutlined />,
            maskClosable: true,
            okText: contextLocale.lang.export,
          },
          confirmProps,
        ),
        {},
        {
          onOk: onOk,
        },
      );
    },
    [exportDataCount, confirmProps, prefixCls, onOk],
  );
  var showConfirm = function showConfirm() {
    if (exportDataCount === 0) {
      message.error(contextLocale.lang.error);
      return;
    }
    confirm(defaultConfirmProps);
  };
  var exportDropdown = useMemo(
    function () {
      var res =
        dropdown === null || dropdown === void 0
          ? void 0
          : dropdown.map(function (item) {
              return _objectSpread(
                _objectSpread({}, item),
                {},
                {
                  confirm: noSecondConfirmation
                    ? undefined
                    : _objectSpread(_objectSpread({}, defaultConfirmProps), item.confirm),
                  onClick: onOk.bind(null, item.type),
                },
              );
            });
      return res;
    },
    [dropdown, defaultConfirmProps, onOk, noSecondConfirmation],
  );
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    dropdown
      ? /*#__PURE__*/ React.createElement(
          BatchedActions,
          {
            menu: exportDropdown,
            getPopupContainer: getPopupContainer,
          },
          /*#__PURE__*/ React.createElement(
            Button,
            _objectSpread(
              _objectSpread(
                {
                  className: classes,
                },
                rest,
              ),
              {},
              {
                // onClick={showConfirm}
                icon: /*#__PURE__*/ React.createElement(ExportOutlined, {
                  style: {
                    marginRight: 4,
                  },
                }),
              },
            ),
            children || contextLocale.lang.export,
            /*#__PURE__*/ React.createElement(ArrowDownSOutlined, {
              style: {
                marginLeft: 4,
              },
            }),
          ),
        )
      : /*#__PURE__*/ React.createElement(
          Button,
          _objectSpread(
            _objectSpread(
              {
                className: classes,
                icon: /*#__PURE__*/ React.createElement(ExportOutlined, {
                  style: {
                    marginRight: 4,
                  },
                }),
              },
              rest,
            ),
            {},
            {
              onClick: noSecondConfirmation ? props.onClick : showConfirm,
            },
          ),
          children || contextLocale.lang.export,
        ),
  );
};
export default ExportButton;
